(ns dre.widgets.top-terms.views
  (:require
   [dre.app.events :as app-events]
   [dre.components.widget.events :as wevents]
   [dre.components.widget.views :as widget-base]
   [dre.components.widget.views.common :refer [no-result title-with-filter]]
   [dre.components.widget.views.table-list :refer [table-list]]
   [dre.i18n.views :refer [tr]]
   [dre.page-util :refer [nbsp]]
   [dre.components.widget.db :as wdb]
   [dre.widgets.top-terms.events :as events]
   [re-frame.core :as rf]))

(defn widget-content
  [data]
  (if (not (seq data))
    [no-result true]
    [:span
     [table-list "top-terms-table" data {:without-percentage? true}]]))

(defn- controls
  []
  [:span
   {:on-click #(rf/dispatch [::events/toggle-title-filter])}
   [:input {:type "checkbox"
            :on-change identity
            :checked @(rf/subscribe [::events/in-titles-only?])}]
   nbsp
   [:label "In titles only"]
   nbsp])

(defn view
  [id title]
  (let [user @(rf/subscribe [::app-events/user])
        loading? @(rf/subscribe [::events/loading?])
        done? @(rf/subscribe [::events/done?])
        default-type "ALL"
        export-counts (-> (wdb/get-widget-options-by-id id)
                          :export-counts)
        selected-type @(rf/subscribe [::wevents/selection id ::category])
        export-count @(rf/subscribe [::wevents/get-export-count id])
        selected-type (if (not selected-type)
                        default-type
                        selected-type)
        data @(rf/subscribe [::events/data selected-type])]
    [widget-base/view
     id
     [title-with-filter title id]
     [widget-content data]
     nil
     nil
     {:csv-event [::events/export selected-type export-count]
      :export-counts export-counts
      :export-image? true
      :controls [controls]
      :selections
      [{:id ::category
        :class :top-terms-dropdown
        :type :dropdown
        :on-change (fn [x]
                     (rf/dispatch [::events/trigger-fetch-top-terms-fast x])
                     x)
        :default-option default-type
        :options (events/cooccurrence-types user)}]}
     {:loading? loading?}]))
